import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SystemCategory } from './message-banner';

@Injectable({
  providedIn: 'root'
})
export class SystemCategoryService {

  private api = environment.urls.baseApiUrl + '/SystemCategories';

  constructor(private http: HttpClient) { }

  GetAllSystemCategories() {
    return this.http.get<SystemCategory[]>(this.api);
  }

}
